export enum FilterHome {
  UNFILTERED = 'UNFILTERED',
  PAY = 'PAY',
  DETAIL = 'DETAIL',
  HISTORIC = 'HISTORIC',
}
